import { render, staticRenderFns } from "./output_1.vue?vue&type=template&id=6b3836e8&scoped=true&"
import script from "./output_1.vue?vue&type=script&lang=js&"
export * from "./output_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3836e8",
  null
  
)

export default component.exports